import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";

const importAll = (r) => r.keys().map(r);
const ProvidersImages = importAll(
  require.context(
    "../assets/images/providers",
    false,
    /\.(jpg|jpeg|png|gif|webp)$/
  )
);

const Providers = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const loadImages = async () => {
      const loadedImages = await Promise.all(ProvidersImages);
      setImages(loadedImages);
    };

    loadImages();
  }, []);

  const uniqueImages = [...new Set(images)];

  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={10}
      slidesPerView={8}
      loop={true}
      autoplay={{ delay: 3500, disableOnInteraction: false }}
      /*  style={{ width: "100%", height: "auto" }} */
    >
      {uniqueImages.map((slide, i) => {
        return (
          <>
            <SwiperSlide key={i}>
              <img
                src={slide}
                alt={slide.alt ?? `Slide ${i}`}
                key={i}
                style={{ width: "100px", borderRadius: "8px" }}
                loading={i > 0 ? "lazy" : "eager"}
              />
            </SwiperSlide>
          </>
        );
      })}
    </Swiper>
  );
};

export default Providers;
